<template>
  <div>
    <Header page="my_page"/>
    <b-container class="mt-5">
      <b-row class="mt-30">
        <b-col cols="12" lg="3" class="mypage__sidebar">
          <SidebarMypage myPage="information"/>
        </b-col>
        <b-col cols="12" lg="9" class="table--mypage pl-70">
          <div class="w-100">
            <b-row class="infor-row">
              <b-col cols="4" class="pl-0">
                <div class="vendor-title">社員コード</div>
              </b-col>
              <b-col cols="8">
                <div class="vendor-content-infor">{{user.employee_code}}</div>
              </b-col>
            </b-row>
            <b-row class="infor-row">
              <b-col cols="4" class="pl-0">
                <div class="vendor-title">所属</div>
              </b-col>
              <b-col cols="8">
                <div class="vendor-content-infor">{{user.position}}</div>
              </b-col>
            </b-row>
            <b-row class="infor-row">
              <b-col cols="4" class="pl-0">
                <div class="vendor-title">電話番号</div>
              </b-col>
              <b-col cols="8">
                <div class="vendor-content-infor">{{show(user.phone)}}</div>
              </b-col>
            </b-row>
            <b-row class="infor-row border-0">
              <b-col cols="4" class="pl-0">
                <div class="vendor-title">メールアドレス</div>
              </b-col>
              <b-col cols="8">
                <div class="vendor-content-infor">{{user.email}}</div>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-center mb-30">
              <button v-b-modal="`modalChangePassword`" class="btn btn-secondary changePass fixed-width btn-rounder mr-30">
                <i class="icon-i-edit"></i>
                <span>パスワードを変更する</span>
              </button>
              <button class="btn btn-mypageEdit fixed-width btn-rounder " @click.prevent="editMypage">
                <i class="icon-i-edit"></i>
                <span>編集</span>
              </button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <ModalChangePassword />
  </div>
</template>

<script>
import SidebarMypage from '@/views/Employee/MyPage/SidebarMypage'
import ModalChangePassword from '@/components/share/ChangePassword'
import Header from '@/components/share/Header'
import {mapState} from 'vuex'
export default {
  name: 'DetailMypage',
  components: {
    Header,
    SidebarMypage,
    ModalChangePassword
  },
  computed: {
    ...mapState({
      user: state => state.allAuth.user
    })
  },
  methods: {
    editMypage () {
      this.$router.push(`/employee/me/edit`)
    },
    show (value) {
      return value || ''
    }
  },
  mounted () {
    this.$store.dispatch('allAuth/getProfile')
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
  @import '@/assets/stylesheet/user/detail_user.scss';
  @import "@/assets/stylesheet/admin/vendor.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/MyPage/DetailMypage.vue